import type { RouteRecordRaw } from 'vue-router'

export enum Page {
  Signpost = 'SignpostPage',
  SignIn = 'SignInPage',
  ForgottenPassword = 'ForgottenPasswordPage',
  PasswordReset = 'PasswordResetPage',
  SignUp = 'SignUpPage',
  FinishSignUp = 'FinishSignUpPage',
  Trips = 'TripsPage',
  Map = 'MapPage',
  Profile = 'ProfilePage',
  TripDetail = 'TripDetailPage',
  TripRatings = 'TripRatingsPage',
  Dashboard = 'DashboardPage',
  ArticleDetail = 'ArticleDetailPage',
  Settings = 'SettingsPage',
  DeleteAccount = 'DeleteAccountPage',
  FavoriteTrips = 'FavoriteTripsPage',
  FavoriteTripDetail = 'FavoriteTripDetailPage',
  FinishedTrips = 'FinishedTripsPage',
  FinishedTripDetail = 'FinishedTripDetailPage',
  BookmarkedArticles = 'BookmarkedArticlesPage',
  BookmarkedArticleDetail = 'BookmarkedArticleDetailPage',
  PartnerLocationDetail = 'PartnerLocationDetailPage',
  TripSuggestionDetail = 'TripSuggestionDetailPage',
  TripSuggestionContribute = 'TripSuggestionContributePage',
  MyTripSuggestions = 'MyTripSuggestionsPage',
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/AppPublicLayout.vue'),
    meta: {
      isPublic: true,
    },
    children: [
      {
        path: '',
        name: Page.Signpost,
        component: () => import('pages/public/SignpostPage.vue'),
      },
      {
        path: 'signin',
        name: Page.SignIn,
        component: () => import('pages/public/SignInPage.vue'),
      },
      {
        path: 'forgot-password',
        name: Page.ForgottenPassword,
        component: () => import('pages/public/ForgottenPasswordPage.vue'),
      },
      {
        path: 'reset-password',
        name: Page.PasswordReset,
        component: () => import('pages/public/ResetPasswordPage.vue'),
      },
      {
        path: 'signup',
        name: Page.SignUp,
        component: () => import('pages/public/SignUpPage.vue'),
      },
      {
        path: 'finish-signup',
        name: Page.FinishSignUp,
        component: () => import('pages/public/FinishSignUpPage.vue'),
      },
    ],
  },
  {
    path: '/app',
    component: () => import('layouts/AppMainLayout.vue'),
    children: [
      {
        path: 'dashboard',
        children: [
          {
            path: '',
            name: Page.Dashboard,
            component: () => import('pages/authenticated/DashboardPage.vue'),
          },
          {
            path: ':articleSlug',
            name: Page.ArticleDetail,
            component: () => import('pages/authenticated/ArticleDetailPage.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'map',
        name: Page.Map,
        component: () => import('pages/authenticated/MapPage.vue'),
      },
      {
        path: 'trips',
        children: [
          {
            path: '',
            name: Page.Trips,
            component: () => import('pages/authenticated/TripsPage.vue'),
          },
          {
            path: ':slug',
            name: Page.TripDetail,
            component: () => import('pages/authenticated/TripDetailPage.vue'),
            props: true,
          },
          {
            path: ':slug/ratings',
            name: Page.TripRatings,
            component: () => import('pages/authenticated/TripRatingsPage.vue'),
            props: true,
          },
          {
            path: ':slug/partner-locations/:partnerLocationId',
            name: Page.PartnerLocationDetail,
            component: () => import('pages/authenticated/PartnerLocationDetailPage.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'trip-suggestions',
        children: [
          {
            path: ':id',
            name: Page.TripSuggestionDetail,
            component: () =>
              import('pages/authenticated/TripSuggestionDetailPage.vue'),
            props: true,
          },
          {
            path: ':id/contribute',
            name: Page.TripSuggestionContribute,
            component: () =>
              import('pages/authenticated/TripSuggestionContributePage.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            name: Page.Profile,
            component: () => import('pages/authenticated/profile/ProfilePage.vue'),
          },
          {
            path: 'settings',
            children: [
              {
                path: '',
                name: Page.Settings,
                component: () => import('pages/authenticated/profile/SettingsPage.vue'),
              },
              {
                path: 'delete-account',
                name: Page.DeleteAccount,
                component: () => import('pages/authenticated/profile/DeleteAccountPage.vue'),
              },
            ],
          },
          {
            path: 'favorite-trips',
            children: [
              {
                path: '',
                name: Page.FavoriteTrips,
                component: () => import('pages/authenticated/profile/FavoriteTripsPage.vue'),
              },
              {
                path: ':slug',
                name: Page.FavoriteTripDetail,
                component: () => import('pages/authenticated/TripDetailPage.vue'),
                props: true,
              },
            ],
          },
          {
            path: 'finished-trips',
            children: [
              {
                path: '',
                name: Page.FinishedTrips,
                component: () => import('pages/authenticated/profile/FinishedTripsPage.vue'),
              },
              {
                path: ':slug',
                name: Page.FinishedTripDetail,
                component: () => import('pages/authenticated/TripDetailPage.vue'),
                props: true,
              },
            ],
          },
          {
            path: 'bookmarked-articles',
            children: [
              {
                path: '',
                name: Page.BookmarkedArticles,
                component: () => import('pages/authenticated/profile/BookmarkedArticlesPage.vue'),
              },
              {
                path: ':articleSlug',
                name: Page.BookmarkedArticleDetail,
                component: () => import('pages/authenticated/ArticleDetailPage.vue'),
                props: true,
              },
            ],
          },
          {
            path: 'my-trip-suggestions',
            name: Page.MyTripSuggestions,
            component: () =>
              import('pages/authenticated/profile/MyTripSuggestionsPage.vue'),
          },
        ],
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
]

export default routes
